export const MODAL_HEIGHT_CSS_VAR = '--modal-viewport-height';
